import { render, staticRenderFns } from "./ResponsesDialog.vue?vue&type=template&id=47d16192"
import script from "./ResponsesDialog.vue?vue&type=script&lang=js"
export * from "./ResponsesDialog.vue?vue&type=script&lang=js"
import style0 from "./ResponsesDialog.vue?vue&type=style&index=0&id=47d16192&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports